<template>
	<div class="legend">
		<div class="ui list">
			<div class="item">{{ currentDayText }}: {{currentDate}}</div>
			<div v-if="updatedAt" class="item">Data da Atualização: {{updatedAtDate}}</div>
			<div v-if="filteredAt" class="item">Data de Referência: {{filteredAtDate}}</div>
			<div v-if="frequency" class="item">Frequência: {{frequency}}</div>
		</div>
	</div>
</template>

<script>
  import {momentMixin, numeralMixin} from '@/modules/neodash/mixins';
  import { i18nService } from '@/services';

  export default {
    props: {
      updatedAt: {
        type: Date
      },

      filteredAt: {
        type: [Date, String]
      },

      currentDayText: {
        type: String,
        default: i18nService.i18n('Common.ActualDate')
      },

      frequency: {
        type: String
      }
    },

    computed: {
      currentDate() {
        return this.formatDate(new Date(), 'DD/MM/YYYY');
      },

      updatedAtDate() {
        return this.formatDate(this.updatedAt, 'DD/MM/YYYY');
      },

      filteredAtDate() {
        if (typeof this.filteredAt === 'string') {
          return this.filteredAt;
        }
        return this.formatDate(this.filteredAt, 'MM/YYYY');
      }
    },

    mixins: [numeralMixin, momentMixin]
  };
</script>

<style lang="scss" scoped>
	.legend {
		background-color: #ffffff;
		border: 1px solid #212121;
		color: #212121;
		font-weight: 400;
		padding: 4px 5px 5px;
		text-align: left;
		float: right;
		margin-top: -1px;
		margin-bottom: -2px;

		.item {
			line-height: 0.925 !important;
			font-size: 0.7125rem;
		}
	}

	@media print {
		.legend {
			.item {
				line-height: 0.80525 !important;
			}
		}
	}
</style>
